import router from "./router.js";

export default {
  router
};